const LogLevel = {
  Error: 1,
  Warning: 2,
  Info: 3,
  Debug: 4
};

export default LogLevel